<template>
  <div class="setting-wrapper">
      <div class="setting-head">
          <div>{{setting.Key}}</div>
          <div><i class="material-icons expand-shrink-icon" @click="toggle" >{{expandShrink}}</i></div>
     </div>
      <div class="setting-translations" v-if="expanded">
          <SettingTranslation v-for="(translation, index) in setting.Translation" :translation="translation" @saveTranslation="save" :key="index"></SettingTranslation>
      </div>
      <div v-if="expanded && !allTranslationsAvailable" style="padding:5px 20px">
        <form v-on:submit.prevent="addNewTranslation" style="padding:15px;border:1px solid #e0e0e0" v-if="addingNewTranslation">
            <div style="display:flex;">
                <input placeholder="Translation" style="margin-right:10px" v-model="newSettingTextTranslation" />
                    <select style="display:block;width:50%" v-model="newSettingTextLanguage">
                        <option v-for="(lang, index) in nonTranslatedLanguages" :value="lang.id" :key="index">{{lang.name}}</option>
                    </select>
            </div>
            <div style="display:flex">
                <button class="btn" type="submit" :disabled="postingTranslation">{{addTranslationBtnText}}</button>
                <a class="btn" style="margin-left:10px" @click="addingNewTranslation = false">
                    <i class="material-icons">undo</i>
                </a>
            </div>
        </form>
        <button class="btn btn-flat" type="submit" v-if="!addingNewTranslation" @click="addingNewTranslation = true">Add New Translation</button>
      </div>
  </div>
</template>
<script>
import SettingTranslation from './TextSettingTranslation'
export default {
  name: "TextSettings",
  props: {
      setting:Object
  },
  components:{
      SettingTranslation
  },
  data(){
      return{
          expanded:false,
          expandShrink:"expand_more",
          addingNewTranslation:false,
          newSettingTextTranslation:"",
          newSettingTextLanguage:"",
          nonTranslatedLanguages:[],
          postingTranslation:false,
          addTranslationBtnText:"Add",
          allTranslationsAvailable:false,
      }
  },
  methods:{
    toggle(){
        this.expandShrink = this.expanded ? "expand_more" : "expand_less";
        this.expanded = !this.expanded; 
    },
    save(child){
        var setting = {
                "key":this.setting.Key,
                "phrase":{
	                "translations":this.setting.Translation,
	                "attachments":null
                }
        };
        this.$http.put("/settings/applicationtext", setting).then(r => {
               child.editing = false;
               child.savingTranslation = false;
          }).catch(r => {
                 M.toast({html:"Some error occured please try again!"});

          })
    },
    addNewTranslation(){
          this.addTranslationBtnText = "Adding...";
          this.postingTranslation  = true;
          var translation = { "text":this.newSettingTextTranslation, "language":this.newSettingTextLanguage };
          
          this.setting.Translation.push(translation);
          var vm = this;
          var setting = {
                "key":this.setting.Key,
                "phrase":{
	                "translations":this.setting.Translation,
	                "attachments":null
                }
            };
          this.$http.put("/settings/applicationtext", setting).then(r => {
                vm.addTranslationBtnText = "Add";
                vm.postingTranslation  = false;
                vm.addingNewTranslation = false;
                var index = vm.nonTranslatedLanguages.findIndex(p => p.id == this.newSettingTextLanguage)
                vm.nonTranslatedLanguages.splice(index,1);
                if(vm.nonTranslatedLanguages.length > 0){
                    vm.newSettingTextLanguage = vm.nonTranslatedLanguages[0].id;
                }else{
                    vm.allTranslationsAvailable = true;
                }
                vm.newSettingTextTranslation = "";
          }).catch(r => {
                 M.toast({html:"Some error occured please try again!"});
                 vm.addTranslationBtnText = "Add";
                 vm.postingTranslation  = false;
                 vm.addingNewTranslation = false;

          })
    },
},
mounted(){
 var translatedLang = [];
 this.setting.Translation.forEach(function(t){
     translatedLang.push(t.language);
 }); 
 var vm = this;
  this.$store.languages.forEach(function(lang){
      if(translatedLang.indexOf(lang.id) < 0){
          vm.nonTranslatedLanguages.push(lang);
      }
  })

  if(this.nonTranslatedLanguages.length > 0){
      this.newSettingTextLanguage = this.nonTranslatedLanguages[0].id;
  }else{
      this.allTranslationsAvailable = true;
  }
}
}
</script>
<style scoped>
.setting-wrapper{
    border: 1px solid #e0e0e0;
}
.setting-head{
    font-size: 18px;
    font-weight: 600;
    background: #efefef;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.setting-translations{
    padding:5px 20px;
}
.expand-shrink-icon:hover{
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/TextSettings.vue